import { useMemo } from 'react';
import { Typography } from '@mui/material';
import { useTheme } from '@emotion/react';

// our utils
import { dataIsValid, dollarFormatter } from 'shared/utils';

function EstimatedValueMessage({ estimatedValue }) {
	const SoraTheme = useTheme();
	const { primary } = SoraTheme.palette;

	const hasValidEstimatedValue = useMemo(
		() => estimatedValue > 0,
		[estimatedValue]
	);

	const formattedEstimatedValue = useMemo(
		() => hasValidEstimatedValue && dollarFormatter.format(estimatedValue),
		[estimatedValue, hasValidEstimatedValue]
	);

	if (!hasValidEstimatedValue) {
		return (
			<Typography variant="subtitle1" sx={{ color: primary.indigo }}>
				Estimator did not
				<br /> find enough comps
			</Typography>
		);
	}

	return (
		<Typography variant="h4" sx={{ color: primary.indigo }}>
			{formattedEstimatedValue}
		</Typography>
	);
}

export default EstimatedValueMessage;
